import { render } from "./PatientChangePassword.vue?vue&type=template&id=7d1ed255&scoped=true"
import script from "./PatientChangePassword.vue?vue&type=script&lang=js"
export * from "./PatientChangePassword.vue?vue&type=script&lang=js"

import "./PatientChangePassword.vue?vue&type=style&index=0&id=7d1ed255&scoped=true&lang=css"

import exportComponent from "/Applications/PROJECTS/HMS-MAIN/PORTAL/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7d1ed255"]])

export default __exports__